import { render, staticRenderFns } from "./Contratos.vue?vue&type=template&id=c9d4b92a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Contratos.vue?vue&type=script&lang=js&"
export * from "./Contratos.vue?vue&type=script&lang=js&"
import style0 from "./Contratos.vue?vue&type=style&index=0&id=c9d4b92a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d4b92a",
  null
  
)

export default component.exports